import mapFunction from './mapResources';

export default mapFunction('employee_orders', {
    isFetching: false,
    items: [] 
});
